

const Type4FlightTopFilters = (props) => {

    const {
        flights,
    } = props;

    return <div style={{marginBottom: 0}} className="flex items-center justify-between mb-8">
        <div>
            <h2 className="text-lg font-extrabold text-slate-900">Available Flights</h2>
            <p className="text-sm font-medium text-slate-500 mt-1">
                Showing <span className="text-indigo-600 font-bold">{flights.length}</span> best offers
            </p>
        </div>
        <div className="flex items-center gap-4 bg-white p-1 rounded-xl border border-slate-200">
            <button className="px-4 py-2 bg-slate-900 text-white rounded-lg text-xs font-bold">Cheapest</button>
            <button className="px-4 py-2 text-slate-500 hover:text-slate-900 rounded-lg text-xs font-bold transition-colors">Fastest</button>
            <button className="px-4 py-2 text-slate-500 hover:text-slate-900 rounded-lg text-xs font-bold transition-colors">Recommended</button>
        </div>
    </div>
}

export default Type4FlightTopFilters;